<template>
  <form data-vv-scope="CalendarEvent">

    <!-- {{startDate}} -->
   
    <!-- <pre>{{ userList }}</pre>
    <pre>{{ clientList }}</pre> -->
    <!-- <pre> {{ editingObject }}</pre> -->
    <vs-input
      class="w-full mb-2"
      placeholder="Add Title"
      v-model="title"
      v-validate="'required'"
      data-vv-name="title"
      autofocus
    />
    <div
      v-if="errors.has('CalendarEvent.title')"
      style="color: red"
      class="invalid-feedback"
    >
      {{ errors.first("CalendarEvent.title") }}
    </div>

    <vs-checkbox v-model="all_day_event" class="my-2"
      >All Day Event</vs-checkbox
    >

    <!-- Radio Button For Selecting Types -->
    <!-- {{editingObject}} -->
    <div v-if="!editingObject">
      <div class="flex flex-wrap -mx-2">
        <label class="w-full ml-4">Scheduling Type</label>

        <vs-radio
          v-model="recurring_type"
          vs-name="radios1"
          vs-value="1"
          class="my-2 mx-2"
          >Daily</vs-radio
        >
        <vs-radio
          v-model="recurring_type"
          vs-name="radios1"
          vs-value="2"
          class="my-2 mx-2"
          >Weekly</vs-radio
        >
        <vs-radio
          v-model="recurring_type"
          vs-name="radios1"
          vs-value="4"
          class="my-2 mx-2"
          >Monthly</vs-radio
        >
      </div>
      <div v-if="recurring_type == 2">
        <v-select
          class="w-full my-2"
          multiple
          :options="weekOption"
          v-model="schedule_frequency_week_day"
          label="name"
          :reduce="(item) => item.value"
          v-validate="'required'"
          placeholder="WeekDays"
          data-vv-name="weekDay"
        >
        </v-select>
        <div
          v-if="errors.has('CalendarEvent.weekDay')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.weekDay") }}
        </div>
      </div>
      <div>
        <v-select
          class="w-full my-2"
          multiple
          v-if="recurring_type == 4"
          :options="monthDay"
          v-model="schedule_frequency_month_day"
          v-validate="'required'"
          placeholder="Monthday"
          data-vv-name="monthday"
        >
        </v-select>
        <div
          v-if="errors.has('CalendarEvent.monthday')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.monthday") }}
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-2">
      <div class="sm:w-1/2 w-full px-2 mb-2">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
            :config="configdateTimePickerTest"
            label="Time"
            class="w-full"
            v-model="schedule_start_date"
            placeholder="Schedule Start Date"
            data-vv-name="schedule start date"
            v-validate="'required'"
          />
          <span class="material-icons" data-toggle>calendar_today</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule start date')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule start date") }}
        </div>
      </div>
      <div class="sm:w-1/2 w-full px-2 mb-2" v-show="!all_day_event">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
                     v-if="!all_day_event"
            v-validate="'required'"
            :config="configTime"
            label="Time"
            class="w-full"
            v-model="schedule_from_time"
            placeholder="Select Time"
            data-vv-name="schedule start time"
          />
          <span class="material-icons" data-toggle>arrow_drop_down</span>
        </div>
         <div
          v-if="errors.has('CalendarEvent.schedule start time')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule start time") }}
        </div>
      </div>
      <div class="sm:w-1/2 w-full px-2 mb-2" v-if="!editingObject">
        <!-- {{event.course_start_time}} -->
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
           :config="configdateTimePickerTest"
            label="Time"
            class="w-full"
            data-vv-name="schedule end date"
            v-model="schedule_end_date"
            placeholder="Schedule End Date"
            v-validate="'required'"
          />
          <span class="material-icons" data-toggle>calendar_today</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule end date')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule end date") }}
        </div>
      </div>
      <div class="sm:w-1/2 w-full px-2 mb-2" v-show="!all_day_event">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
          v-if="!all_day_event"
            :config="configTime"
            label="Time"
            class="w-full"
            v-validate="'required'"
            v-model="schedule_to_time"
            placeholder="Select Time"
            data-vv-name="schedule end time"
          />
          <span class="material-icons" data-toggle>arrow_drop_down</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule end time')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule end time") }}
        </div>
      </div>
    </div>
    <vs-textarea
      class="w-full mb-2"
      placeholder="Location"
      v-model="location"
      v-validate="'required'"
      data-vv-name="Location"
    ></vs-textarea>
    <div
      v-if="errors.has('CalendarEvent.Location')"
      style="color: red"
      class="invalid-feedback"
    >
      {{ errors.first("CalendarEvent.Location") }}
    </div>
    <!-- <input
    v-model="event.eventTextColor"
      class="w-full mb-2"
      type="color"
    /> -->
    <div class="cstmColorHolder">
      <div
        class="cstmColorDiv"
        @click="selectColor(index)"
        :class="{ active: activeIndex === index }"
        :style="{ backgroundColor: presetColor }"
        v-for="(presetColor, index) in presetColors"
        :key="index"
      ></div>
      <div class="moreColor">
        <input
          v-model="colour_code"
          type="color"
          v-validate="'required'"
          data-vv-name="textColor"
        />
        <a>More Colors</a>
      </div>
      <div
        v-if="errors.has('CalendarEvent.textColor')"
        style="color: red"
        class="invalid-feedback"
      >
        {{ errors.first("CalendarEvent.textColor") }}
      </div>
    </div>
    <content-component v-model="description"
    label="Add Description"
    ></content-component>
   
    <!-- {{attachCLientList}} -->
    <div class="mt-4 text-right">
      <vs-button type="border" @click="cancelEvent">Cancel</vs-button>
      <vs-button class="ml-2" @click="saveEvent()" v-if="!editingObject">Save</vs-button>
            <vs-button class="ml-2" @click="updateEvent()" v-else>Update</vs-button>

    </div>
  </form>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import vSelect from 'vue-select'
import { CreateGeneralEventApi, UpdateGeneralEventApi } from '@/api/schedulerApi'
import { UserMixins } from '@/mixins/UserMixins'
import { eventMixin } from '../mixins/eventMixin'

export default {
  components: {
    flatPickr,
    ContentComponent,
    vSelect
  },
  props: {
    startDate: {},
    endDate: {},
    editingObject: {
      type: Object,
      default: null
    },
    customer_id: {
      type: Number,
      required: true,
    }
  },
  mixins: [UserMixins, eventMixin],
  data () {
    return {
     
      weekOption: [
        {
          name: 'Sunday',
          value: 'Sun'
        },
        {
          name: 'Monday',
          value: 'Mon'
        },
        {
          name: 'Tuesday',
          value: 'Tue'
        },
        {
          name: 'Wednesday',
          value: 'Wed'
        },
        {
          name: 'Thursday',
          value: 'Thu'
        },
        {
          name: 'Friday',
          value: 'Fri'
        },
        {
          name: 'Saturday',
          value: 'Sat'
        }
      ],

      monthDay: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31
      ],
      id: null,
      title: '',
      schedule_start_date: null,
      schedule_end_date: null,
      location: null,
      description: null,
      schedule_from_time: null,
      schedule_to_time: null,
      eventTypePicked: null,
      colour_code: '#d50000',
      schedule_frequency_week_day: [],
      schedule_frequency_month_day: [],
      recurring_type: 1,
      all_day_event: false,
      presetColors: [
        '#d50000',
        '#f4511e',
        '#e67c73',
        '#f6bf26',
        '#3f51b5',
        '#0b8043',
        '#039be5',
        '#33b679',
        '#7986cb',
        '#8e24aa',
        '#616161',
        '#b39ddb',
        '#e737e5',
        '#70d7dc'
      ],
      activeIndex: undefined,
     
      configdateTimePickerTest: {
        altInput: true,
        altFormat: 'F j, Y',
        // dateFormat: 'Y-m-d',
        wrap: true,
        dateFormat: 'Y-m-d',
        minDate:new Date()
      },
      configTime: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        enableSeconds: true,
        dateFormat: 'H:i:S',
        wrap: true
      }
    }
  },
  created () {

    this.schedule_start_date = new Date(this.startDate)
    
    if (this.editingObject) {
      console.log(this.editingObject)
      this.title = this.editingObject.title
      this.schedule_start_date = new Date(this.editingObject.schedule_date)
      this.schedule_from_time = this.editingObject.schedule_from_time
      this.schedule_to_time = this.editingObject.schedule_to_time
      this.location = this.editingObject.location
      this.colour_code = this.editingObject.colour_code
      this.description = this.editingObject.description
      this.all_day_event =  this.editingObject.all_day_event          
      console.log(this.editingObject)
    }
     
   
    // console.log(this.editingObjet)
  },
  /* beforeDestroy () {
    this.editingObject = null
  },
   */
  mounted () {
    /* this.event.course_start = this.startDate
    this.event.course_end = this.endDate */
  },
  methods: {
    cancelEvent () {
      this.$emit('cancelEventEmit')
    },
    saveEvent () {

      // console.log(checkingDateToday)
        
      this.$validator.validateAll('CalendarEvent').then((valid) => {
        console.log(valid)
        if (valid) {
          const payload = {
            all_day_event: this.all_day_event,
            title: this.title,
            schedule_start_date: this.schedule_start_date,
            schedule_end_date: this.schedule_end_date,
            location: this.location,
            description: this.description,
            schedule_from_time: this.schedule_from_time,
            schedule_to_time: this.schedule_to_time,
            colour_code: this.colour_code,
            schedule_frequency_week_day: this.schedule_frequency_week_day,
            schedule_frequency_month_day: this.schedule_frequency_month_day,
            recurring_type: this.recurring_type,
            custom:1,
            customer_id: this.customer_id,
          }
          console.log(payload)
          const checkingDateToday = this.validateTodayDate(new Date(), new Date(this.schedule_start_date))
          const hasCheckingStartEndDate = this.validateTodayDate(new Date(this.schedule_start_date), new Date(this.schedule_end_date))

          if (checkingDateToday <= 0 && hasCheckingStartEndDate <= 0) {
            this.savingEvent(payload)
          } else {
            let message = ''
            console.log(checkingDateToday)
            if (checkingDateToday > 0) {
              message = 'Event can not be scheduled on a past date'
            } else if (hasCheckingStartEndDate > 0) {
              message = 'Start Date must be less than end date'
            }
            this.showSuccessMessage('Error', `${message}`, 'danger')
          }
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
        
      })
     
    },
    updateEvent () {
      const payload = {
        id:this.editingObject.id,
        all_day_event: this.all_day_event,
        title: this.title,
        schedule_date: this.schedule_start_date,
        location: this.location,
        description: this.description,
        schedule_from_time: this.schedule_from_time,
        schedule_to_time: this.schedule_to_time,
        colour_code: this.colour_code,
        custom:1,
        customer_id: this.customer_id,
      }
      console.log(payload)
      this.$validator.validateAll('CalendarEvent').then((res) => {
        console.log(res)
        this.updatingEvent(payload)
      })

      // this.$emit('createEvent', this.event)
    },
    
    async updatingEvent (payload) {
      try {
       

        const data = await UpdateGeneralEventApi(payload)
        this.$emit('saveEventEmit', 'Updated')
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    },
    async savingEvent (payload) {
      try { 
        const data = await CreateGeneralEventApi(payload)
        this.$emit('saveEventEmit', 'Added')
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    },
    selectColor (index) {
      // alert(this.presetColors[index])
      this.colour_code = this.presetColors[index]
      this.activeIndex = index
      // alert(this.eventTextColor)
    }
  }
}
</script>

<style>
.cstmColorHolder {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
  padding: 5px;
  border-radius: 6px;
  margin: 10px 0;
}
.cstmColorDiv {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 5px;
}
.cstmColorDiv.active {
  position: relative;
}
.cstmColorDiv.active:before {
  content: "\2713";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
}
.moreColor {
  position: relative;
}
.moreColor input[type="color"] {
  position: absolute;
  left: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.cstm-flat-pickr-holder {
  position: relative;
}
.cstm-flat-pickr-holder .material-icons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  cursor: pointer;
}

@media (max-width: 580px) {
  .cstmColorHolder {
    justify-content: flex-start;
  }
}
</style>